import service from '@/store/services/settings/schedules-service';

const state = {
    list: {},
    schedule: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, schedule) => {
        state.schedule = schedule;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
    get ({ commit, dispatch }, params) {
        return service.get(params)
            .then(schedule => {
                commit('SET_RESOURCE', schedule);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(schedule => {
                commit('SET_RESOURCE', schedule);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((schedule) => {
                commit('SET_RESOURCE', schedule);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((schedule) => {
                commit('SET_RESOURCE', schedule);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },

    reRunAssignment ({ commit, dispatch }, params) {
        return service.reRunAssignment(params)
            .then((schedule) => {
            commit('SET_RESOURCE', schedule);
        });
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    schedule: state => state.schedule,
    dropdown: (state) => {
        return state.list.map(station => ({
            id: station.id,
            name: station.name,
            short_name: station.short_name,
            code: station.code
        }));
    }
};

const schedules = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default schedules;
